import React from 'react'

const Footer = () => {
  return (
    <div className='' style={{backgroundColor:'black'}}>
        <div className='container py-5'>
            <h5 className='text-center mt-5 mb-5 my-5' style={{color:'white'}}>Copyright © Arhsys LLC - All Rights Reserved.</h5>
        </div>
    </div>
  )
}

export default Footer